<template>
    <div>
        <Field v-model="content" :field="field" @error="error" v-bind="$attrs" :extendErrors="errors"/>
        <slot></slot>
    </div>
</template>

<script>
import IdentityFields from '../identityFields/IdentityFields'
import _ from 'lodash'

export default {
    name: 'DateTime',
    components: {
        Field: IdentityFields
    },
    props: {
        label: {
            type: String
        },
        value: {
            type: String | Number
        },
        name: {
            type: String
        },
        rules: {
            type: Object
        },
        type: {
            type: String,
            default: 'text'
        },
        description: {
            type: String,
        },
        errors: {
            type: Array,
            default: () => []
        },
        disablePastDates: {
            type: Boolean,
            default: false
        },
        minuteStep: {
            type: Number,
            default: 1
        }
    },
    data: function() {
        return {}
    },
    computed: {
        constraints() {
            let rules = this.rules
            
           this.rules["custom_data"] = {
                datetime: {
                    disablePastDates: this.disablePastDates,
                    minuteStep: this.minuteStep,
                    format: "yyyy-MM-dd HH:mm"
                }
            }

            return rules
        },
        content: {
            get() {
                let valObj = {}
                valObj[this.field.key] = this.value

                return valObj
            },

            set(val) {
                if (this.rules.expression !== undefined) {
                    this.errors = this.rules.expression(val)
                    this.error({
                        field: this.name,
                        error: this.errors.length > 0
                    })
                }

                this.$emit('input', val[this.field.key])
            }
        },

        field() {
            return {
                type: "datetime",
                module: "picker",
                key: this.name,
                name: this.label,
                description: this.description,
                constraints: this.constraints
            }
        }
    },
    methods: {
        error(errors) {
            this.$emit('error', errors)
        }
    }
}
</script>